import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const FirebaseConfig = {
  apiKey: "AIzaSyDdDY-A9k2uwsqzKLRpA_kfrxspEpmp2RM",
  authDomain: "rapidoo-dashboard.firebaseapp.com",
  projectId: "rapidoo-dashboard",
  storageBucket: "rapidoo-dashboard.firebasestorage.app",
  messagingSenderId: "28608752286",
  appId: "1:28608752286:web:1d012f8f48d3c65e43298f",
  measurementId: "G-3PQHDG8W3H"
};

const tokenConfig = {
  vapidKey:
    'BGEaPrvUtH6UlBPTE0vF6fgc09NshkEGi_CkhsoueNwp_xUa5DV-1af4BrBoYWYHMROo6xDeRqTIXOT5esuFMFo'
};

let app, messaging;

class FcmNotification {
  static init() {
    if (!app) {
      app = initializeApp(FirebaseConfig);
      messaging = getMessaging(app);
    }
  }
  static setNotificationHandler(notificationHandler) {
    onMessage(messaging, notificationHandler);
  }

  static async getDeviceToken() {
    const token = await getToken(messaging, tokenConfig).catch((error) => {
      console.error('[FcmNotification] Failed to get token:', error);
      return null;
    });
    return token || '';
  }
}

export { FcmNotification };
